import React, { FC } from 'react'

import { Card } from 'src/components/atoms'
import { ExternalUserDetailBasicInfo } from 'src/components/organisms'

import { ExternalUserEntity } from 'src/types'

type Props = {
  externalUser: ExternalUserEntity
  className?: string
}

export const ExternalUserDetailBasicInfoCard: FC<Props> = ({ externalUser, className }) => {
  return (
    <div className={className}>
      <Card padding="--s1">
        <ExternalUserDetailBasicInfo externalUser={externalUser} />
      </Card>
    </div>
  )
}
